<nz-spin [nzSpinning]="loading$ | async">
  <form [formGroup]="form" nz-form class="form" nzLayout="horizontal">
    <div class="drawer-form-wrapper">
      <!-- Branding Selection -->
      <div class="branding-logo-wrapper">
        <div class="form-grid">
          <nz-form-item>
            <nz-form-label nzFor="brandingName">Branding</nz-form-label>
            <nz-form-control nzHasFeedback [nzErrorTip]="brandingError">
              <nz-select
                formControlName="brandingName"
                (ngModelChange)="onBrandingChange($event)"
                nzShowSearch>
                <nz-option
                  *ngFor="let brand of logos$ | async"
                  [nzLabel]="brand.productName"
                  [nzValue]="brand.id">
                </nz-option>
              </nz-select>
              <ng-template #brandingError>
                <span *ngIf="form.get('brandingName')?.hasError('required')">
                  Please select a Branding
                </span>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <!-- Product Name -->
          <nz-form-item>
            <nz-form-label nzFor="productName" nzRequired>
              Product Name
            </nz-form-label>
            <nz-form-control [nzErrorTip]="productNameError">
              <input type="text" nz-input formControlName="productName" />
              <ng-template #productNameError let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Product Name is required
                </ng-container>
                <ng-container *ngIf="control.hasError('minlength')">
                  Product Name must be at least 2 characters
                </ng-container>
                <ng-container *ngIf="control.hasError('maxlength')">
                  Product Name cannot exceed 50 characters
                </ng-container>
                <ng-container *ngIf="control.hasError('pattern')">
                  Product Name can't include special characters
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="form-grid">
          <!-- Logo Upload -->
          <nz-form-item *ngIf="showCancelLogoBtn">
            <nz-form-label nzFor="file">Logo</nz-form-label>
            <nz-upload
              [nzFileList]="fileList"
              [nzRemove]="handleFileRemove"
              [nzMultiple]="false"
              [nzBeforeUpload]="beforeUpload"
              [nzIconRender]="iconTemplate"
              nzListType="picture"
              [nzAccept]="'.png,.jpg,.jpeg'"
              nzDrop
              class="file-upload">
              <button nz-button type="button">
                <div class="upload-icon">
                  <svg-icon
                    [title]="'Upload File'"
                    src="/assets/icon/icon-upload.svg"
                    class="icon s-12"></svg-icon>
                </div>
                <div class="wrapper">
                  <p class="text s-14 fw-600 green">
                    Click to upload
                    <span class="text s-14 fw-400">or drag and drop</span>
                  </p>
                  <p class="text s-12 fw-400">
                    Supported formats: jpg, jpeg & png
                  </p>
                </div>
              </button>
            </nz-upload>
          </nz-form-item>

          <!-- Current Logo Display -->
          <nz-form-item class="current-logo-section">
            <div
              *ngIf="(this.logos$.value?.length || 0) > 1"
              nzFor="logo"
              class="display-flex justify-content-between mb-6">
              <div>Current Logo</div>
              <button
                type="button"
                nz-button
                nzType="text"
                [disabled]="!selectedLogo"
                (click)="showConfirmDialog = true"
                class="primary-text-btn">
                Remove
              </button>
            </div>
            <div class="logo-container" *ngIf="selectedLogo">
              <img [src]="selectedLogo" alt="Organization Logo" />
            </div>
          </nz-form-item>
        </div>
      </div>
      <div class="display-flex drawer-footer">
        <button
          type="button"
          nz-button
          *ngIf="showCancelLogoBtn"
          nzType="default"
          (click)="handleCancel()">
          Cancel
        </button>

        <button
          nz-button
          nzType="primary"
          (click)="handleCreate()"
          [disabled]="
            (fileList.length === 0 || !form.get('productName')?.valid) &&
            isCreateMode
          "
          *ngIf="showCreateButton">
          {{ isCreateMode ? 'Save' : 'Create' }}
        </button>
        <div *ngIf="!showCreateButton"></div>
        <button
          nz-button
          nzType="primary"
          (click)="handleEdit()"
          [disabled]="!form.get('productName')?.valid && isEditing"
          *ngIf="showEditButton">
          {{ isEditing ? 'Save' : 'Edit' }}
        </button>
      </div>
    </div>
  </form>

  <app-confirm-dialog
    [isVisible]="showConfirmDialog"
    [title]="'Delete Logo'"
    [message]="
      'Are you sure you want to delete this Logo? This action cannot be undone.'
    "
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Delete'"
    (confirmed)="handleDelete()"
    (cancelled)="handleClose()"
    (closed)="handleClose()">
  </app-confirm-dialog>
</nz-spin>
<ng-template #iconTemplate let-file>
  <svg-icon
    [title]="'Image File'"
    src="/assets/icon/icon-report-green.svg"
    class="icon s-12"></svg-icon>
</ng-template>
